<template>
  <div class="finish">
    <div class="finish__dialog">
      <img class="finish__img" src="~assets/img/rocket-finish.svg" alt="">
      <h1 class="finish__title">You've finished</h1>
      <router-link class="custom-btn custom-btn--green mb-2" :to="{ name: 'results' }">
        View results
      </router-link>
      <div class="finish__org">
        <p class="my-0">Organomyx assessment complete</p>
        <dots-number activeDots='5'/>
      </div>
    </div>
  </div>
</template>

<script>
import DotsNumber from '@/components/Evaluation/Dots';

export default {
  components: { DotsNumber },
  beforeCreate() {
    if (this.$current_user.current_evaluation !== this.$route.params.id &&
      this.$current_user.completed_sections === '5') {
      this.$router.push({ name: 'start' });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Evaluation/Finish.vue